import API from 'api';
import FetchWrapper from 'helpers/fetch-wrapper';
import AppLocalStorage from 'storages/app-local-storage';
import Const from 'constants';

let Message = {
    getSportMessages() {
        return (dispatch, getState) => {
            const state = getState();
            const {sportConfig} = state;

            const sport = sportConfig.getSport();
            const site = sportConfig.getSite();
            const gameType = sportConfig.getGameType();

            let url = API.to('GET_SPORT_MESSAGES', {sport: sport, site: site, gameType: gameType});

            return FetchWrapper.fetchGet(url).then((json) => {
                let data = this.filterMessages(json.data);

                dispatch({
                    type: Const.SET_SPORT_MESSAGE,
                    data: data,
                });

                return Promise.resolve(json);
            });
        };
    },
    getMessages() {
        return (dispatch, getState) => {
            let url = API.to('GET_MESSAGES');
            return FetchWrapper.fetchGet(url).then((json) => {
                let data = this.filterMessages(json.data);

                dispatch({
                    type: Const.SET_MESSAGES,
                    data: data,
                });

                return Promise.resolve(json);
            });
        };
    },
    setViewedMessage(id) {
        return (dispatch, getState) => {
            const state = getState();

            let messagesJson = AppLocalStorage.getValue('messages');
            let messages = {};

            if (messagesJson.length > 0) {
                messages = JSON.parse(messagesJson);
            }
            if (typeof messages[id] === 'undefined') {
                messages[id] = true;
            }

            AppLocalStorage.setValue('messages', JSON.stringify(messages));

            return dispatch({
                type: Const.SET_MESSAGES,
                data: this.filterMessages(state.messagesData.messages.data),
            });
        };
    },
    filterMessages(data) {
        let handledMessages = [];
        let storedMessages = AppLocalStorage.getValue('messages');
        let result = data;

        if (storedMessages.length > 0) {
            let messages = JSON.parse(storedMessages);
            data.forEach(function (item) {
                if (messages[item.id] !== true) {
                    handledMessages.push(item);
                }
            });
            result = handledMessages;
        }

        return result;
    },
};

export default Message;
